import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {DatePipe} from '@angular/common';

declare const $: any;

@Component({
    selector: 'app-question-date-of-birth',
    templateUrl: './question-date-of-birth.component.html',
    styleUrls: ['./question-date-of-birth.component.scss'],
    standalone: false
})
export class QuestionDateOfBirthComponent implements OnInit {

  @Input() question: Question;
  @Input() birthDate: any;
  @Input() birthMonth: any;
  @Input() birthYear: any;
  @Input() value: string;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Output() questionAnswer = new EventEmitter<any>();
  months = [
    'January',
    'February',
    'March', 'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
    if (this.value) {
      const date = new Date(this.value);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
    if (this.question && this.question?.answer) {
      const date = new Date(this.question.answer);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.value = changes?.value?.currentValue;
    if (this.value) {
      const date = new Date(this.value);
      this.birthDate = date.getDate();
      this.birthMonth = this.datePipe.transform(date, 'MMMM');
      this.birthYear = date.getFullYear();
    }
  }
  dropdownChange(event): void {
    if (event) {
      this.birthMonth = event;
    }
    this.submitAnswer();
  }

  inputChange(): void {
    this.submitAnswer();
  }

  submitAnswer(): void {
    if (this.birthDate && this.birthMonth && this.birthYear && this.birthYear.toString().length === 4) {
      const date = this.birthDate + ' ' + this.birthMonth + ' ' + this.birthYear;

      if (this.question) {
        this.question.answer = this.datePipe.transform(new Date(date), 'yyyy-MM-dd');
        this.questionAnswer.emit(this.question);
      } else {
        this.questionAnswer.emit(this.datePipe.transform(new Date(date), 'yyyy-MM-dd'));
      }
    }
  }


}
